/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExamDto
 */
export interface ExamDto {
    /**
     * 
     * @type {number}
     * @memberof ExamDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamDto
     */
    showId?: number;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    reference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExamDto
     */
    no?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamDto
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamDto
     */
    priceNoMember?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExamDto
     */
    bookable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    breedOnly?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExamDto
     */
    sort?: number;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    gweType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    gweLevel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    horseAge?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExamDto
     */
    onlyYouthRider?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ExamDto
     */
    cancellableUntil?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ExamDto
     */
    addUntil?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ExamDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDto
     */
    leisureStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExamDto
     */
    isBigHorse?: number | null;
}

/**
 * Check if a given object implements the ExamDto interface.
 */
export function instanceOfExamDto(value: object): value is ExamDto {
    return true;
}

export function ExamDtoFromJSON(json: any): ExamDto {
    return ExamDtoFromJSONTyped(json, false);
}

export function ExamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'showId': json['showId'] == null ? undefined : json['showId'],
        'name': json['name'] == null ? undefined : json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'reference': json['reference'] == null ? undefined : json['reference'],
        'description': json['description'] == null ? undefined : json['description'],
        'no': json['no'] == null ? undefined : json['no'],
        'price': json['price'] == null ? undefined : json['price'],
        'priceNoMember': json['priceNoMember'] == null ? undefined : json['priceNoMember'],
        'bookable': json['bookable'] == null ? undefined : json['bookable'],
        'breedOnly': json['breedOnly'] == null ? undefined : json['breedOnly'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'gweType': json['gweType'] == null ? undefined : json['gweType'],
        'gweLevel': json['gweLevel'] == null ? undefined : json['gweLevel'],
        'horseAge': json['horseAge'] == null ? undefined : json['horseAge'],
        'onlyYouthRider': json['onlyYouthRider'] == null ? undefined : json['onlyYouthRider'],
        'cancellableUntil': json['cancellableUntil'] == null ? undefined : (new Date(json['cancellableUntil'])),
        'addUntil': json['addUntil'] == null ? undefined : (new Date(json['addUntil'])),
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'leisureStatus': json['leisureStatus'] == null ? undefined : json['leisureStatus'],
        'isBigHorse': json['isBigHorse'] == null ? undefined : json['isBigHorse'],
    };
}

export function ExamDtoToJSON(json: any): ExamDto {
    return ExamDtoToJSONTyped(json, false);
}

export function ExamDtoToJSONTyped(value?: ExamDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'showId': value['showId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'reference': value['reference'],
        'description': value['description'],
        'no': value['no'],
        'price': value['price'],
        'priceNoMember': value['priceNoMember'],
        'bookable': value['bookable'],
        'breedOnly': value['breedOnly'],
        'sort': value['sort'],
        'gweType': value['gweType'],
        'gweLevel': value['gweLevel'],
        'horseAge': value['horseAge'],
        'onlyYouthRider': value['onlyYouthRider'],
        'cancellableUntil': value['cancellableUntil'] == null ? undefined : ((value['cancellableUntil'] as any).toISOString()),
        'addUntil': value['addUntil'] == null ? undefined : ((value['addUntil'] as any).toISOString()),
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString()),
        'leisureStatus': value['leisureStatus'],
        'isBigHorse': value['isBigHorse'],
    };
}

